import{convertDecorationDataToDraft as t}from"ricos-content/libs/toDraftData";import{Decoration_Type as a}from"wix-rich-content-common";const e=(o={},r=!1)=>r?t(a.LINK,o):o;export{e as createLinkData};
//# sourceMappingURL=createLinkData.js.map
